import { Platform } from "react-native"

import { logs } from "@opentelemetry/api-logs"
import { OTLPLogExporter } from "@opentelemetry/exporter-logs-otlp-http"
import { resourceFromAttributes } from "@opentelemetry/resources"
import {
  LoggerProvider,
  BatchLogRecordProcessor,
} from "@opentelemetry/sdk-logs"

import config from "../config"

const signozLoggerProvider = new LoggerProvider({
  resource: resourceFromAttributes({
    "service.name": `treefort-app-${Platform.OS}`,
    "service.version": config.APP_VERSION,
    "tenant.id": config.TENANT_ID,
    "client.id": config.CLIENT_ID,
    "deployment.environment.name": config.ENV,
  }),
  processors: [
    new BatchLogRecordProcessor(
      new OTLPLogExporter({
        url: config.SIGNOZ_LOGS_INGESTION_ENDPOINT,
      }),
    ),
  ],
})

export function initializeSignoz() {
  logs.setGlobalLoggerProvider(signozLoggerProvider)
}
